import React from 'react';
import { NavLink } from 'react-router-dom';

/*
 * Menu intermedio delle Impostazioni (come LUME, layout/AppLayout.tsx › SettingsNav): la voce «Impostazioni»
 * del menu principale apre la prima pagina e, in tutte le pagine di impostazione, fra il menu e la pagina
 * compare un secondo menu verticale stretto con le voci. Sul telefono le stesse voci sono una fila di
 * pulsanti in cima alla pagina.
 * Il cambio di email e password non sta qui: è nella pagina Account, dal nome in alto a destra.
 */
export const VOCI_IMPOSTAZIONI = {
    struttura: [
        { to: '/struttura/strumenti/abbonamento-info', label: 'Abbonamento' },
    ],
    superadmin: [
        { to: '/superadmin/strumenti/certificati-medici', label: 'Certificati medici' },
        { to: '/superadmin/strumenti/posta-in-uscita', label: 'Posta in uscita' },
        { to: '/superadmin/strumenti/versione-app', label: "Versione dell'app" },
        { to: '/superadmin/strumenti/funzioni', label: 'Funzioni' },
        { to: '/superadmin/manager-subscriptions/settings', label: 'Abbonamenti Manager' },
        { to: '/superadmin/strumenti/debug-fatture', label: 'Debug fatture' },
    ],
};

export const primaVoceImpostazioni = (userType) => VOCI_IMPOSTAZIONI[userType]?.[0]?.to || '/';

export const isPaginaImpostazioni = (userType, pathname) =>
    (VOCI_IMPOSTAZIONI[userType] || []).some((v) => pathname === v.to || pathname.startsWith(`${v.to}/`));

export const MenuImpostazioni = ({ userType, perTelefono = false }) => (
    <nav className={perTelefono ? 'sid-impostazioni-menu-m' : 'sid-impostazioni-menu'} aria-label="Impostazioni">
        {!perTelefono && <div className="sid-impostazioni-menu__titolo">Impostazioni</div>}
        {(VOCI_IMPOSTAZIONI[userType] || []).map((v) => (
            <NavLink key={v.to} to={v.to} className={({ isActive }) => (isActive ? 'is-attiva' : '')}>{v.label}</NavLink>
        ))}
    </nav>
);

export default MenuImpostazioni;
